.layer {
  position: absolute;
  z-index: 15;
  inset: 0;
  display: grid;
  min-height: 8rem;
  padding: var(--space-4);
  background: color-mix(in srgb, var(--color-profile-content, #f1f5ff) 55%, transparent);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  place-items: center;
  overflow: auto;
}
.layer[data-page] {
  position: fixed;
  top: var(--app-header-height, 0px);
  padding-bottom: calc(var(--dock-clearance, 0px) + var(--space-4));
}
.layer[data-in-flow] {
  position: relative;
  inset: auto;
  grid-area: 1 / 1;
  overflow: visible;
}
.controls {
  position: relative;
  display: grid;
  width: min(100%, 26rem);
  justify-items: center;
  gap: var(--space-4);
  color: var(--color-text-primary);
  text-align: center;
}
.message {
  font-family: var(--font-family-display);
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.6;
}
.controls button {
  min-width: min(100%, 12rem);
  max-width: 100%;
}
